import Swiper from "swiper";

export const createComponentsDestinationToTravel = () => {
	if (document.body.className.match(`.destination-to-travel`)) {
		const generateSwiperSetup = idName => {
			const arraySetup = {
				pagination: {
					el: `#${idName} .swiper-pagination`,
					clickable: true
				},
				simulateTouch: false,
				slidesPerView: 6,
				slidesPerGroup: 6,
				slidesPerColumn: 1,
				spaceBetween: 30,
				navigation: {
					nextEl: `#${idName} .swiper-button-next`,
					prevEl: `#${idName} .swiper-button-prev`,
				},
				breakpoints: {
					768: {
						simulateTouch: true,
						slidesPerView: 1,
						slidesPerGroup: 1,
						slidesPerColumn: 1
					}
				}
			};

			return arraySetup;
		};

		new Swiper(
			`#swiper-destination-to-travel-brazil .swiper-container`,
			generateSwiperSetup("swiper-destination-to-travel-brazil")
		);
		new Swiper(
			`#swiper-destination-to-travel-others .swiper-container`,
			generateSwiperSetup("swiper-destination-to-travel-others")
		);
	}
};
